<!-- USER LOGIN & REGISTRATION SECTION -->
<template>
    <div class="container my-3">  
        <div class="mx-auto">
            <p align="center">
                <img  id="logo" v-bind:src="this.$brandSettings.logoImage" width="40%" style="display:block"/>
            </p>
        </div>

        <div v-if="!loged">
            <loginSection v-on:SetUpUsertype="SetUpUsertype($event)" v-on:changeTokenValue="TokenHasChanged($event)" ></loginSection>
            <div v-if="!loged && isSafari" class="safari-warning">For technical reasons, we recommend using the User Management Panel with a different browser than Safari, e.g. Chrome, Opera or Firefox. </div>
            <!--<AdminTools :isLoggedIn="loggedin" :usertype="usertype" :accesstoken="token" :orgs="orgs"/>-->
        </div>
        <div v-else>
            <div class="container">
                <div class="row">
                    <div class="col-2">
                        <img  id="logo" v-bind:src="this.$brandSettings.logoImage" width="100%" style="display:block"/>
                    </div>
                </div>
            </div>
                

            <Menu :userType="usertype" :token="token" v-on:ChangeMenu="nextMenu($event)" :address="address" :email="email"/>
                
            <div v-if="this.menuTab === 'AdminTools'">
                <UsersManager :token="token" :usertype="usertype" :organisationID="organisationID"/>
            </div>
            <div v-if="(this.menuTab === 'OrgaTools') && (usertype === 'admin')">
                <OrganizationManager :accesstoken="token" :usertype="usertype" :isLoggedIn="loged"/>
                <OrgFilesDownload :isLoggedIn="loggedin" :usertype="usertype" :accesstoken="token" :orgs="orgs"/>
            </div>
            
            <div v-show="(this.menuTab === 'ContentTools')">
                <ContentManagement  :token="token" :Organization="organisationID"/>
            </div>

            <div v-show="(this.menuTab === 'Customize')">
                <Customization :usertype="usertype" :token="token" :organization="organisationID"/>
            </div>
            
        </div>
    </div> 
</template>

<script>
import axios from 'axios';
import login from '@/components/Siemens_Login.vue';
import OrgFilesDownload from '@/components/AdminTools/OrgFilesDownload.vue';
import UsersManager from '@/components/Tools/Siemens_UsersManager.vue';
import Menu from '@/components/Tools/Menu.vue';
import Customization from '@/components/Menus/customization.vue'
import ContentManagement from '@/components/Menus/ContentManagement.vue'
import OrganizationManager from '@/components/AdminTools/OrganizationManager'

    export default{
        components: {
            'ContentManagement': ContentManagement,
            'loginSection': login,
            'OrgFilesDownload':OrgFilesDownload,
            'UsersManager':UsersManager,
            'Menu':Menu,
            'Customization':Customization,
            'OrganizationManager':OrganizationManager
        },
        props:['msg'],
        data(){
            return{
                address:"to be specified", //loopback access point
                loggedin:false,
                name:"",
                description:"",
                username:"",
                password:"",
                email:"t@t.t",
                organisation:"",
                usertype:"",
                token:"",
                fields:[{username:'username'}, {usertype:'usertype'}, {email:'email'},{organisationID:'organisationID'}, {password:'password'},{action:'action'}],
                organisationID:"",
                orgs:[{id:'id',name:'name'}],
                loged:false,
                menuTab: 'AdminTools',
                isSafari: false
            }
        },
        beforeMount(){
            const expression = "code=[^&^=]*";
            if(window.location.href.search(expression)>-1){
                const code = window.location.href.match(expression).pop();
                const token = code.split("=")[1];
                const domain=self.location.host;
                const url = domain =="localhost" || domain=="giri" || domain=="127.0.0.1"?
                "https://localhost:3000/":
                "https://"+self.location.host+":3000/";
                this.address = url;
                
                axios.post(url+"api/auth0s/validateAuth0Token",{"token":token}).then(
                    (response)=>{
                        const resp = response.data;
                        const expre = "^[A-Za-z0-9]+$";
                        if((resp.id && resp.userId)?
                            resp.id.match(expre) && resp.userId.match(expre) && resp.id.length > 0 && resp.userId.length > 0:
                            false
                        ){
                            console.log(resp.id);
                            this.token = resp.id;
                            axios.get(this.address+'api/UserAccounts/'+resp.userId+'?access_token='+this.token).then(response2=>{
                                console.log(response2.data);
                                this.SetUpUsertype(response2.data)
                                window.history.pushState("","","/");
                                this.loged = true;
                            })
                        }
                    },
                    (err)=>{
                        console.log(err);
                    }
                );
            }
        },
        mounted(){
            this.CheckBrowser();
            /*var domain=self.location.host;
            if(domain =="localhost" || domain=="giri" || domain=="127.0.0.1"){
                console.log("On premise server");
                this.address="https://localhost:3000/";
            }else{
                console.log("Cloud server");
                this.address="https://"+self.location.host+":3000/"
            }*/
        },   
        methods:{
            CheckBrowser(){
                //Check link if more browsers are needed
                //https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser?rq=1
                var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
                if(isSafari){
                    this.isSafari = true;
                }
            },
            SetUpUsertype(data){
                this.usertype=data.usertype
                this.email=data.email
                this.organisationID=data.organisationID

                if(this.usertype=="admin"){
                    axios.get(this.$address+"api/Organisations?access_token="+this.token)
                        .then(response => {
                            this.orgs=response.data
                            console.log(this.orgs)
                        })
                }else{ //for manager
                    axios.get(this.$address+"api/UserAccounts/"+data.id+"/organisation?access_token="+this.token)
                        .then(response => {
                            this.orgs=[response.data]
                        })
                }


                if(this.usertype==="admin"){
                    axios.get(this.$address+"api/UserAccounts?access_token="+this.token)
                        .then(response => {
                            this.fields=response.data
                        })
                }else{
                    this.LoadDataFromDomainOnly()
                }
                //document.getElementById("tablelist").style.display = "block"
                document.getElementById("logo").style.display = "none"
                this.loged = true;

            },
            LoadDataFromDomainOnly(){
                console.log(this.organization)
                axios.get(this.$address+"api/Organisations/"+this.organisationID+"/userAccounts?&access_token="+this.token)
                        .then(response => {
                            this.fields=response.data
                        })
            },
            TokenHasChanged(newToken){
                this.token=newToken
            },
            nextMenu(nxt){
                console.log(nxt);
                this.menuTab = nxt;
            }
        }
        
    }
</script>
<style lang="css" scoped>
.safari-warning{
    border: 1.5px solid red;
    padding: 15px 20px;
    width: 50%;
    margin: auto ;
    position: relative;
    font-size: 15px;
}
</style>
